import { Component, OnInit, Output, EventEmitter } from '@angular/core'
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal',
  exportAs: 'modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  @Output() closed: EventEmitter<any> = new EventEmitter<any>()

  constructor(
    private router: Router
  ) { }

  ngOnInit() { }

  close ($event) {
    this.router.navigate([{ outlets: { modal: null } }]);
    this.closed.next($event);
  }
}
